export default function CheckboxField({ id, label, checked, onChange, disabled = false }) {
  return (
    <label htmlFor={id} className="flex cursor-pointer items-center gap-3">
      <input
        id={id}
        type="checkbox"
        className="h-5 w-5 rounded-md border-outline-variant bg-surface-container-low text-primary focus:ring-primary/40"
        checked={checked}
        onChange={(event) => onChange(event.target.checked)}
        disabled={disabled}
      />
      <span className="text-sm font-medium text-secondary">{label}</span>
    </label>
  )
}
